import { ReactElement } from 'react';
import { AWARD_IMAGES } from '../assets/brands';
import { UIText } from '@/ui';
import styles from './accolades.module.scss';
import { useRegion } from '../providers/region-provider';
import { ResolvedRegion } from '../providers/region-provider/models';
import { useCommonTranslation } from '../hooks';

interface AccoladeEntry {
    src: string;
    alt: string;
}

const REGION_ACCOLADES: Record<ResolvedRegion, AccoladeEntry[][]> = {
    eu: [
        [
            {
                src: AWARD_IMAGES.britishExForces,
                alt: 'British Ex-Forces Entrepreneur of the Year'
            },
            {
                src: AWARD_IMAGES.protectionOfLife,
                alt: 'Protection of Life Award from Geovation'
            }
        ],
        [
            {
                src: AWARD_IMAGES.ukHealthAndSafetyTech,
                alt: 'Health and Safety Tech Innovation 2024'
            },
            {
                src: AWARD_IMAGES.techNationRisingStars,
                alt: 'Tech Nation Rising Stars Alumni 2024'
            }
        ]
    ],
    us: [
        [
            {
                src: AWARD_IMAGES.exForces,
                alt: 'Ex-Forces Entrepreneur of the Year'
            },
            {
                src: AWARD_IMAGES.protectionOfLife,
                alt: 'Protection of Life Award from Geovation'
            }
        ],
        [
            {
                src: AWARD_IMAGES.healthAndSafetyTech,
                alt: 'Health and Safety Tech Innovation 2024'
            },
            {
                src: AWARD_IMAGES.techNationRisingStars,
                alt: 'Tech Nation Rising Stars Alumni 2024'
            }
        ]
    ]
};

export function Accolades(): ReactElement | null {
    const { t } = useCommonTranslation();
    const { resolvedRegion } = useRegion();

    const accolades = REGION_ACCOLADES[resolvedRegion];
    if (!accolades.length) return null;

    return (
        <div className={styles.container}>
            <UIText variant="h1" textAlign="center" type="link">
                {t('components.accolades.title')}
            </UIText>
            <div className={styles.logos}>
                {accolades.map((row, rowIndex) => (
                    <div key={rowIndex} className={styles.logoRow}>
                        {row.map((accolade) => (
                            <div
                                key={accolade.alt}
                                className={styles.logoContainer}
                            >
                                <img
                                    src={accolade.src}
                                    alt={accolade.alt}
                                    className={styles.logoImage}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
